import { LegalEntityAuditApiModel } from "../../../../legalEntity/legalEntityAuditTab/LegalEntityAudit.types";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export interface IProcessingActivityAuditsHooksProps {
    processingActivityId: string;
}

export default function useProcessingActivityAudits(props: IProcessingActivityAuditsHooksProps) {
    const externalAuditsUrl = `/ProcessingActivityOverview/${props.processingActivityId}/audits`;
    const {
        isLoading: isLoadingExternalAudits,
        data: externalAudits,
        refetch: refetchExternalAudits,
    } = useDotLegalQuery<Array<LegalEntityAuditApiModel>>(externalAuditsUrl);

    return {
        externalAudits,
        isLoadingExternalAudits,
        refetchExternalAudits,
    };
}
